import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import PalletIcon from '../../../../../generic/icons/IconLib/PalletIcon'
import { CardRow } from '../../../../../generic/ui/CardRow'
import { ScrollArea } from '../../../../../generic/ui/Surface'
import { RadioSlider } from '../../../../../generic/ui/Toggles/RadioSlider'
import { IPackageLogData } from '../../../../../modules/API/Drivers/models/packageLogData'
import { IconSlot, IdText, PrimaryName } from '../Components/DriversCardParts'
import { PACK_TYPE_LABELS, TAB_ALL } from '../helpers/packTypes'

type Props = {
  list: IPackageLogData[]
}

const StatisticPackageModal = ({ list }: Props) => {
  const [activeTab, setActiveTab] = useState<string>(TAB_ALL)

  const tabs = useMemo(() => {
    const types = Array.from(new Set(list.map((item) => item.PD_Type)))
    return [
      { id: TAB_ALL, label: TAB_ALL, badge: list.length },
      ...types.map((type) => ({
        id: type,
        label: PACK_TYPE_LABELS[type] ?? type,
        badge: list.filter((item) => item.PD_Type === type).length,
      })),
    ]
  }, [list])

  const render = useMemo(() => {
    const filtered =
      activeTab === TAB_ALL ? list : list.filter((item) => item.PD_Type === activeTab)
    // Копия перед sort: он мутирует массив, а list — это пропс.
    return [...filtered].sort((a, b) => Number(a.HasTeuda) - Number(b.HasTeuda))
  }, [activeTab, list])

  const lastIndex = render.length - 1

  return (
    <Container>
      <RadioSlider
        items={tabs}
        value={activeTab}
        onChange={setActiveTab}
        ariaLabel='סוג אריזה'
      />

      <ScrollArea>
        {render.map((item, idx) => (
          <CardRow
            key={`${item.PD_Type}-${item.PackID}`}
            $columns='auto minmax(0, 1fr) auto'
            $mobileColumns='auto minmax(0, 1fr) auto'
            $minHeight='auto'
            $hover={false}
            $isLast={idx === lastIndex}
          >
            <CardRow.Cell>
              <IconSlot $muted>
                {item.PD_Type === 'א' ? <PackageIcon /> : <PalletIcon />}
              </IconSlot>
            </CardRow.Cell>

            <CardRow.Cell>
              <PrimaryName>{item.Pack_Name.trim()}</PrimaryName>
            </CardRow.Cell>

            <CardRow.Cell $align='end'>
              <IdText>{item.Qty}</IdText>
            </CardRow.Cell>
          </CardRow>
        ))}
      </ScrollArea>
    </Container>
  )
}

export default StatisticPackageModal

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  direction: rtl;
`
